<template>
  <div id="index">
    <div class="head">
      <div class="head-left">
        <router-link to="/">
          <img class="logo" src="@/assets/logo.png">

        </router-link>

      </div>
      <div class="head-right">

        <div class="head-right-item">

          <router-link :to="{name: 'Home',path:'/home'}" :class="{active:hshow==1}" hshow="1" @click="hchange">产品介绍</router-link>
          <div class="underline"></div>

        </div>
        <div class="head-right-item" :class="{active:hshow==2}" hshow="2" @click="hchange">
          <router-link :to="{name: 'Tryout',path:'/tryout'}" :class="{active:hshow==2}" hshow="2" @click="hchange">产品试用</router-link>
          <div class="underline"></div>

        </div>
        <div class="head-right-item" :class="{active:hshow==3}" hshow="3" @click="hchange">
          <router-link :to="{name: 'Purchase',path:'/purchase'}" :class="{active:hshow==3}" hshow="3" @click="hchange">产品采购</router-link>
          <div class="underline"></div>

        </div>
        <div class="head-right-item" :class="{active:hshow==4}" hshow="4" @click="hchange">
          <router-link :to="{name: 'FAQ',path:'/faq'}" :class="{active:hshow==4}" hshow="4" @click="hchange">FAQ</router-link>
          <div class="underline"></div>
        </div>


      </div>
    </div>

    <div class="main">

      <div class="banner">
        <el-carousel trigger="click" :interval="7000" height="50.25vw">


          <el-carousel-item>
            <router-link to="/home">
              <img src="../assets/bg1.jpg">
            </router-link>
          </el-carousel-item>


          <el-carousel-item>
            <router-link to="/tryout">
              <img src="@/assets/bg2.jpg">
            </router-link>
          </el-carousel-item>


          <el-carousel-item>
            <router-link to="/purchase">
              <img src="@/assets/bg3.jpg">
            </router-link>
          </el-carousel-item>

        </el-carousel>

      </div>


    </div>

    <div class="foot">

      <div class="foot-content">
        中科劲点(北京)科技有限公司 版权所有

      </div>

      <div class="foot-content">
        地址:北京市海淀区中关村创业大街昊海楼2层   联系方式：137 1787 2355
      </div>
      <div class="foot-content">
        京ICP备15047372号-1 京公网安备 11010802033207
      </div>

    </div>
  </div>
</template>
<script>

export default {
  name: "home",
  data: () => {
    return {

      hshow: 0,
    }
  },
  mounted() {


  },
  methods: {
    hchange: function (event) {
      this.hshow = event.target.getAttribute("hshow");
    }
  }
}


</script>

<style scoped lang="scss">



.banner {
  width: 100%;
  height: 50.25vw;
}

.banner img {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: 50%;
  cursor: pointer;

}

.active {
  color: #ff6500;
  display: block;
}

#home {
  width: 100vw;
}

.head {
  display: flex;
  width: 100vw;
  height: 4.219vw;
  background-color: #393939;
  box-shadow: 0vw 0.26vw 0.583vw 0.25vw rgba(57, 57, 57, 0.27);
  align-items: center;
}

.head-left {
  width: 15.396vw;
  height: 2.604vw;
  margin-left: 2.865vw;
}
.head-left .logo {
  width: 10.396vw;
  margin-top: 0.5vw;
}

.head-right {
  display: flex;
  margin-left: 50.594vw;
}



.head-right-item {
  font-family: PingFang-SC-Bold;
  font-size: 1vw;
  line-height: 4.557vw;
  letter-spacing: 0.042vw;
  color: #ffffff;

}

.head-right-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 3.146vw;
}

.head-right-item :hover {
  color: #ff6500;
}

.underline {
  width: 2.188vw;
  height: 0.217vw;
  background-color: #ff6500;
  margin-top: -0.653vw;
  display: none;
}


.head-right-item:hover .underline {
  display: block;
}


.foot {
  width: 100vw;
  height: 7.24vw;
  background-color: #393939;
  font-family: PingFang-SC-Medium;
  font-size: 0.8vw;
  line-height: 2.188vw;
  letter-spacing: 0.052vw;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}


</style>
